
















































import Vue from 'vue'
import { setCurrentPage } from '../store/actions'
import { EventBus } from '../helpers/EventBus.vue'
import { getPagination, routerReplace } from '../helpers'

interface ILabels {
	prev: string
	next: string
	srGotoPrev: string
	srGotoNext: string
	srPage: string
}

interface PData {
	mobile: boolean
}
interface PMethods {
	setCurrentPage(event: Event, number: number): void
}

interface PComputed {
	pages: number
	currentPage: number
	mayPrev: boolean
	mayNext: boolean
	paginationPages: any
	labels: ILabels
}

interface PProps {}

export default Vue.extend<PData, PMethods, PComputed, PProps>({
	name: 'Pagination',
	data() {
		return {
			mobile: false
		}
	},
	mounted() {
		this.mobile = window.innerWidth < 1024
	},
	computed: {
		paginationPages() {
			const pages = this.$store.getters.pages
			const currentPage = this.$store.getters.page

			return getPagination(pages, currentPage)
		},
		pages() {
			return this.$store.getters.pages
		},
		currentPage() {
			return this.$store.getters.page
		},
		mayPrev() {
			return this.$store.getters.page > 0
		},
		mayNext() {
			return this.$store.getters.page !== this.$store.getters.pages - 1
		},
		labels() {
			const desktop = {
				prev: 'Föregående',
				next: 'Nästa',
				srGotoPrev: 'Gå till ',
				srGotoNext: 'Gå till ',
				srPage: 'sida'
			}
			const mobile = {
				prev: 'Föregående',
				next: 'Nästa',
				srGotoPrev: 'Gå till ',
				srGotoNext: 'Gå till ',
				srPage: 'sida'
			}

			if (this.mobile) return mobile
			return desktop
		}
	},
	methods: {
		setCurrentPage(event, number) {
			event.preventDefault()
			EventBus.$emit('scrollToTop')
			this.$store.dispatch(setCurrentPage({ page: number }))
			routerReplace({
				query: this.$store.getters.getParams
			})
		}
	}
})
